import React, { useEffect, useRef, useState } from "react";
import { useAddVideoMutation } from "../../features/videos/videosApi";
import Success from "../ui/Success";
import styles from "./videoForm.module.css";

export default function VideoAddForm() {
  const titleRef = useRef();
  const descRef = useRef();
  const urlRef = useRef();
  const viewsRef = useRef();
  const durationRef = useRef();
  const createdAtRef = useRef();
  const [isvideoAdded, setIsvideoAdded] = useState(false);

  const [addVideo, { isLoading, isSuccess: isAddVideoSuccess }] =
    useAddVideoMutation();

  const clearForm = () => {
    titleRef.current.value = "";
    descRef.current.value = "";
    urlRef.current.value = "";
    viewsRef.current.value = "";
    durationRef.current.value = "";
    createdAtRef.current.value = "";
  };

  const handleAdd = (e) => {
    e.preventDefault();
    const data = {
      title: titleRef?.current.value,
      description: descRef?.current.value,
      url: urlRef?.current.value,
      views: viewsRef?.current.value,
      duration: durationRef?.current.value,
      createdAt: createdAtRef?.current.value,
    };

    addVideo(data);
  };

  useEffect(() => {
    if (isAddVideoSuccess) {
      clearForm();
      setIsvideoAdded(true);
    }
  }, [isAddVideoSuccess, setIsvideoAdded]);

  return (
    <>
      <div className="justify-center mb-10 space-y-2 flex md:space-y-0">
        <form
          onSubmit={handleAdd}
          className={`${styles.videoForm}  bg-primary border border-slate-50/10 `}
        >
          <div className="formGroup flex items-center justify-between">
            <label htmlFor="titleInput">Title</label>
            <input
              onChange={() => setIsvideoAdded(false)}
              required
              className="bg-slate-900 p-2 "
              type="text"
              id="titleInput"
              ref={titleRef}
            />
          </div>
          <div className="formGroup flex items-center justify-between">
            <label htmlFor="descriptionInput">Description</label>
            <textarea
              onChange={() => setIsvideoAdded(false)}
              rows={5}
              className="bg-slate-900 p-2 "
              type="text"
              id="descriptionInput"
              ref={descRef}
            />
          </div>
          <div className="formGroup flex items-center justify-between">
            <label htmlFor="urlInput">url</label>
            <input
              required
              className="bg-slate-900 p-2 "
              type="text"
              id="urlInput"
              ref={urlRef}
            />
          </div>
          <div className="formGroup flex items-center justify-between">
            <label htmlFor="viewsInput">views</label>
            <input
              onChange={() => setIsvideoAdded(false)}
              required
              className="bg-slate-900 p-2 "
              type="text"
              id="viewsInput"
              ref={viewsRef}
            />
          </div>
          <div className="formGroup flex items-center justify-between">
            <label htmlFor="durationInput">duration</label>
            <input
              onChange={() => setIsvideoAdded(false)}
              required
              className="bg-slate-900 p-2 "
              type="text"
              id="durationInput"
              ref={durationRef}
            />
          </div>
          <div className="formGroup flex items-center justify-between">
            <label htmlFor="createdAtInput">createdAt</label>
            <input
              onChange={() => setIsvideoAdded(false)}
              required
              className="bg-slate-900 p-2 "
              type="date"
              id="createdAtInput"
              ref={createdAtRef}
            />
          </div>
          {isvideoAdded && <Success message={"Video added successfully"} />}
          <button
            disabled={isLoading}
            type="submit"
            className="block ml-auto bg-violet-600 p-2 px-4 rounded-md text-white"
          >
            Add
          </button>
        </form>
      </div>
    </>
  );
}
